module.exports = __webpack_public_path__ + "dcebf947814e1aab12c489851ff2f66f.csv";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/inventory-variance/samples/CostAdjustment.csv
 ** module id = 1303
 ** module chunks = 0
 **/